import { parse } from "./datemath.js";
import dayjs from "dayjs";
import DocumentDO = App.Data.Explorer.DocumentDO;

export function processDates<T>(obj: DocumentDO, base: T): T {
	const result = base;
	for (const key in obj) {
		if (Object.hasOwn(obj, key)) {
			const value = obj[key];
			if (typeof value === "object" && value instanceof Date) {
				result[key] = dayjs(value).format("YYYY-MM-DD HH:mm:ss");
			} else if (typeof value === "object" && value !== null) {
				result[key] = processDates(value, Array.isArray(value) ? [] : {});
			} else {
				result[key] = value;
			}
		}
	}
	return result;
}

export function convertDates(obj) {
	if (Array.isArray(obj)) {
		return obj.map(convertDates);
	}

	if (obj !== null && typeof obj === "object") {
		for (const key in obj) {
			if (obj.hasOwnProperty(key)) {
				const value = obj[key];
				if (
					typeof value === "string" &&
					value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/)
				) {
					obj[key] = new Date(value);
				} else {
					obj[key] = convertDates(value);
				}
			}
		}
	}

	return parseDynamicDocumentDefinitions(obj);
}

export function parseDynamicDocumentDefinitions(obj): DocumentDO {
	// Define the keys to process with specific rounding options
	const keysToProcess = [
		{ name: "to", roundUp: true },
		{ name: "from", roundUp: false },
		{ name: "period_measurement", roundUp: true },
		{ name: "transaction_snapshot", roundUp: true },
	];

	if (Array.isArray(obj)) {
		return obj.map(parseDynamicDocumentDefinitions);
	}

	if (obj !== null && typeof obj === "object") {
		// Create a shallow copy of the object to work with
		const newObj = { ...obj };

		for (const key in newObj) {
			if (newObj.hasOwnProperty(key)) {
				const value = newObj[key];
				const keyObj = keysToProcess.find((k) => k.name === key);

				if (!key.includes("_parsed")) {
					if (keyObj) {
						// Modify the copied object, not the original
						newObj[`${key}_parsed`] = parse(value, keyObj.roundUp)?.toDate();
					} else if (typeof value === "object" && value !== null) {
						// Recursively process and update the copied object
						newObj[key] = parseDynamicDocumentDefinitions(value);
					} else {
						newObj[key] = value;
					}
				}
			}
		}
		return newObj;
	}
	return obj;
}

export function isOldSnapshot(date: dayjs.Dayjs): boolean {
	const parsedDate = date;
	const today = dayjs();

	return !parsedDate.clone().add(1, "second").isSame(today, "day");
}
